import { useEffect } from 'react';
import { removeCookie } from '@namespace/helpers';
import { AB_TEST_COOKIE } from '../../constants';
import { abTestActions } from '../../store';

const { INIT_AB_TESTS } = abTestActions;

const useInitABTest = (abTests) => {
  useEffect(() => {
    if (abTests?.length) {
      INIT_AB_TESTS(abTests);
    } else {
      removeCookie(AB_TEST_COOKIE);
    }
  }, [abTests?.length]);
};

export default useInitABTest;
